import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const buyQuizService = async (
  userToken: string,
  quizId: string | number,
  payWithWallet:number,
  payWithGiftWallet:number,
) => {
  return axiosV3.post(
    `/buy_quiz`,
    {
        quiz_id: quizId,
        pay_with_wallet: payWithWallet,
        pay_with_gift_wallet: payWithGiftWallet
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
